export class ObjectComparer {
    public static arraysDiffer(a: any[], b: any[]): boolean {
        if (a == null || b == null) {
            return a == null && b == null;
        }

        return a.length !== b.length || a.some((item, index) => !ObjectComparer.isSame(item, b[index]));
    }

    /* tslint:disable:ban-types */
    public static objectsDiffer(a: Record<string, any>, b: Record<string, any>): boolean {
        const aProperties = Object.keys(a);
        const bProperties = Object.keys(b);

        return (
            aProperties.length !== bProperties.length ||
            aProperties.some((key) => !ObjectComparer.isSame(a[key], b[key]))
        );
    }
    /* tslint:enable:ban-types */

    public static isSame(a: any, b: any): boolean {
        if (a == null || b == null) {
            return a == null && b == null;
        }

        if (typeof a !== typeof b) {
            return false;
        }

        // otherwise comparison as object always returned false
        if (typeof a === "function") {
            return true;
        }

        if (Array.isArray(a)) {
            return !this.arraysDiffer(a, b);
        }

        if (a instanceof Date && b instanceof Date) {
            return a.getTime() === b.getTime();
        }

        if (typeof a === "object" && a !== null && b !== null) {
            return !this.objectsDiffer(a, b);
        }

        return a === b;
    }

    /*
     * Source: http://snipplr.com/view/36012/javascript-natural-sort/
     */
    public static stringNaturalSortCompare(as: string, bs: string): number {
        const rx = /(\d+)|(\D+)/g;
        const rd = /\d+/;
        const a = as.toLowerCase().match(rx);
        const b = bs.toLowerCase().match(rx);
        while (a.length && b.length) {
            const a1: any = a.shift();
            const b1: any = b.shift();
            if (rd.test(a1) || rd.test(b1)) {
                if (!rd.test(a1)) {
                    return 1;
                }
                if (!rd.test(b1)) {
                    return -1;
                }
                if (a1 !== b1) {
                    return a1 - b1;
                }
            } else if (a1 !== b1) {
                return a1 > b1 ? 1 : -1;
            }
        }
        return a.length - b.length;
    }
}
